var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34277 9.40425C2.34277 8.99004 2.67856 8.65425 3.09277 8.65425H20.9167C21.3309 8.65425 21.6667 8.99004 21.6667 9.40425C21.6667 9.81847 21.3309 10.1543 20.9167 10.1543H3.09277C2.67856 10.1543 2.34277 9.81847 2.34277 9.40425Z",
    fill: "#200E32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6919 13.3097C15.6919 12.8955 16.0277 12.5597 16.4419 12.5597H16.4512C16.8654 12.5597 17.2012 12.8955 17.2012 13.3097C17.2012 13.7239 16.8654 14.0597 16.4512 14.0597H16.4419C16.0277 14.0597 15.6919 13.7239 15.6919 13.3097Z",
    fill: "#200E32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2544 13.3097C11.2544 12.8955 11.5902 12.5597 12.0044 12.5597H12.0137C12.4279 12.5597 12.7637 12.8955 12.7637 13.3097C12.7637 13.7239 12.4279 14.0597 12.0137 14.0597H12.0044C11.5902 14.0597 11.2544 13.7239 11.2544 13.3097Z",
    fill: "#200E32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80811 13.3097C6.80811 12.8955 7.14389 12.5597 7.55811 12.5597H7.56737C7.98158 12.5597 8.31737 12.8955 8.31737 13.3097C8.31737 13.7239 7.98158 14.0597 7.56737 14.0597H7.55811C7.14389 14.0597 6.80811 13.7239 6.80811 13.3097Z",
    fill: "#200E32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6919 17.1962C15.6919 16.782 16.0277 16.4462 16.4419 16.4462H16.4512C16.8654 16.4462 17.2012 16.782 17.2012 17.1962C17.2012 17.6104 16.8654 17.9462 16.4512 17.9462H16.4419C16.0277 17.9462 15.6919 17.6104 15.6919 17.1962Z",
    fill: "#200E32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2544 17.1962C11.2544 16.782 11.5902 16.4462 12.0044 16.4462H12.0137C12.4279 16.4462 12.7637 16.782 12.7637 17.1962C12.7637 17.6104 12.4279 17.9462 12.0137 17.9462H12.0044C11.5902 17.9462 11.2544 17.6104 11.2544 17.1962Z",
    fill: "#200E32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80811 17.1962C6.80811 16.782 7.14389 16.4462 7.55811 16.4462H7.56737C7.98158 16.4462 8.31737 16.782 8.31737 17.1962C8.31737 17.6104 7.98158 17.9462 7.56737 17.9462H7.55811C7.14389 17.9462 6.80811 17.6104 6.80811 17.1962Z",
    fill: "#200E32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0439 1.25C16.4582 1.25 16.7939 1.58579 16.7939 2V5.29078C16.7939 5.70499 16.4582 6.04078 16.0439 6.04078C15.6297 6.04078 15.2939 5.70499 15.2939 5.29078V2C15.2939 1.58579 15.6297 1.25 16.0439 1.25Z",
    fill: "#200E32"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96533 1.25C8.37955 1.25 8.71533 1.58579 8.71533 2V5.29078C8.71533 5.70499 8.37955 6.04078 7.96533 6.04078C7.55112 6.04078 7.21533 5.70499 7.21533 5.29078V2C7.21533 1.58579 7.55112 1.25 7.96533 1.25Z",
    fill: "#200E32"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76749 4.22946C4.76914 3.27729 6.16751 2.8292 7.77096 2.8292H16.2383C17.8457 2.8292 19.2449 3.27695 20.2448 4.23019C21.2504 5.18877 21.7548 6.56558 21.75 8.22326V17.3475C21.75 19.0052 21.243 20.3835 20.2371 21.3439C19.2366 22.2992 17.8377 22.75 16.229 22.75H7.77096C6.16301 22.75 4.76302 22.2898 3.76225 21.3199C2.75774 20.3463 2.25 18.9508 2.25 17.2719V8.22222C2.25 6.56339 2.76004 5.18715 3.76749 4.22946ZM4.80096 5.31664C4.1571 5.92869 3.75 6.87396 3.75 8.22222V17.2719C3.75 18.6473 4.1594 19.6159 4.8062 20.2428C5.45673 20.8733 6.44222 21.25 7.77096 21.25H16.229C17.5663 21.25 18.5528 20.8781 19.2013 20.259C19.8444 19.6449 20.25 18.6969 20.25 17.3475V8.22222L20.25 8.21991C20.2541 6.87107 19.8507 5.92683 19.2098 5.31591C18.5631 4.69941 17.5768 4.3292 16.2383 4.3292H7.77096C6.43772 4.3292 5.45061 4.69907 4.80096 5.31664Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.998c5f113d6d215baf1b6db356fc695d.svg";
export { ForwardRef as ReactComponent };